import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';

// slice 02.1 · paso b.5c — presentacional. La lista de subtareas del panel de detalle (era
// parte de `renderInfoContent` en `ComponentTaskHoy`). El wizard de 5 pasos para crear una
// subtarea nueva se queda container-side (usa `updateTaskInDB`/estado compartido con otras
// partes del panel) y entra acá como el slot `subtaskForm`, rendereado después de la lista —
// mismo patrón que los `render*Popover` de `TaskListView` (b.4a). b′a reemplaza el wizard por
// el form RHF sin tocar el contrato de este componente.
export const TaskSubtasks = ({ subtasks = [], systemUsers = [], onOpenTask, subtaskForm }) => {
    const { t: translate } = useTranslation('tasks');

    return (
        <div className="task-panel-subtasks-area" style={{ marginTop: 'var(--space-5)' }}>
            <div className="description-title-label" style={{ marginBottom: 'var(--space-3)' }}>{translate('modal.nextTasks')}</div>
            <div className="subtasks-list" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {subtasks.map((st) => {
                    const assigneeNick = st.assignee ? st.assignee.split(',')[0].trim() : null;
                    const assigneeUser = assigneeNick ? systemUsers.find(u => u.nick === assigneeNick) : null;

                    return (
                        <div
                            key={st.id}
                            className="subtask-item"
                            style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', padding: 'var(--space-2) var(--space-3)', backgroundColor: 'rgba(255,255,255,0.03)', borderRadius: 'var(--radius-md)', border: '1px solid rgba(255,255,255,0.05)', transition: 'background-color 0.2s' }}
                            onClick={() => onOpenTask(st.id)}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.06)'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.03)'}
                        >
                            {assigneeUser ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
                                    <img src={(assigneeUser['link-profile-img-thumb'] || assigneeUser['link-profile-img']) || `https://api.dicebear.com/7.x/avataaars/svg?seed=${assigneeUser.nick}`} alt={assigneeUser.nick} loading="lazy" style={{ width: '16px', height: '16px', borderRadius: '50%', objectFit: 'cover' }} />
                                    <span style={{ fontSize: '11px', color: '#aaa', fontWeight: '500' }}>{assigneeUser.nick}</span>
                                </div>
                            ) : (
                                <div style={{ width: '14px', height: '14px', borderRadius: 'var(--radius-sm)', border: '1px solid rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    {st.stage === 'done' ? <CheckCircle2 size={10} color="#10b981" /> : (st.stage === 'check' ? <CheckCircle2 size={10} color="#eab308" /> : null)}
                                </div>
                            )}
                            <span style={{ fontSize: '13px', color: '#ccc', textDecoration: st.stage === 'done' ? 'line-through' : 'none', flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{st.title || translate('common.untitled')}</span>
                        </div>
                    );
                })}
                {subtaskForm}
            </div>
        </div>
    );
};

export default TaskSubtasks;
